import type { MetaFunction } from "@remix-run/node";
import {
	Links,
	Meta,
	Outlet,
	Scripts,
	ScrollRestoration,
	useRouteError,
} from "@remix-run/react";
import { captureRemixErrorBoundaryError } from "@sentry/remix";

import { Footer } from "./components/footer";
import { AppHeader } from "./components/navigation";
import "./tailwind.css";

// Fallback for error pages; each route's own meta replaces it.
export const meta: MetaFunction = () => [{ title: "Aplikace Echo" }];

export function Layout({ children }: { children: React.ReactNode }) {
	return (
		<html lang="cs">
			<head>
				<meta charSet="utf-8" />
				<meta name="viewport" content="width=device-width, initial-scale=1" />
				<Meta />
				<Links />
			</head>
			<body>
				{children}
				<ScrollRestoration />
				<Scripts />
			</body>
		</html>
	);
}

export const ErrorBoundary = () => {
	const error = useRouteError();
	captureRemixErrorBoundaryError(error);
	return <div>Něco se pokazilo</div>;
};

export default function App() {
	// Remix already wraps this component in the exported `Layout`; wrapping it
	// again nests <html> inside <body> and breaks hydration (React error #418).
	return (
		<div className="flex flex-col h-screen">
			<AppHeader />
			<main className="flex-grow">
				<Outlet />
			</main>
			<Footer />
		</div>
	);
}
